import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../api/client'
import { useI18n } from '../i18n'

const callbackStorageKey = (code: string) => `swiss_mail_sso_callback:${code}`

export function SSOCallback() {
  const { t } = useI18n()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const code = params.get('code')
    const state = params.get('state')
    if (!code) {
      setError('Missing authorization code')
      return
    }

    const storageKey = callbackStorageKey(code)
    const callbackStatus = sessionStorage.getItem(storageKey)
    if (callbackStatus === 'pending') return
    if (callbackStatus === 'complete') {
      navigate('/user/mail', { replace: true })
      return
    }

    sessionStorage.setItem(storageKey, 'pending')
    api.post<{ accessToken: string; user: { role: string; email: string } }>('/auth/sso/callback', { code, state })
      .then((result) => {
        sessionStorage.setItem(storageKey, 'complete')
        api.setSession(result.accessToken, result.user.role, result.user.email)
        navigate('/user/mail', { replace: true })
      })
      .catch((e: Error) => {
        sessionStorage.removeItem(storageKey)
        setError(e.message)
      })
  }, [navigate, params])

  if (error) return <main className="grid min-h-screen place-items-center p-5">
    <div className="panel max-w-md p-8 text-center">
      <p className="text-destructive">{error}</p>
      <button onClick={() => navigate('/user/login')} className="mt-4 h-10 rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground">{t('common.signIn')}</button>
    </div>
  </main>

  return <main className="grid min-h-screen place-items-center"><p className="text-muted-foreground">{t('common.loading')}</p></main>
}
